export default "__VITE_ASSET__16df811d__"